import { render, staticRenderFns } from "./snippet_header.vue?vue&type=template&id=c0329020"
import script from "./snippet_header.vue?vue&type=script&lang=js"
export * from "./snippet_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports